module.exports = __webpack_public_path__ + "static/media/DOWNLOADS-PitchOn.e013ffac.svg";